// extracted by mini-css-extract-plugin
module.exports = {"navbar":"Navbar_navbar__2KrFT","active":"Navbar_active__3b0QJ","container-wide":"Navbar_container-wide__2d4A1"};